

function isalready_selected_any_product(input){
  let current = input.parentElement;  
  while (current) {
    if (current.classList.contains("cust-form-wrapp")) {
      current.classList.remove("is_selected");
    }
    current = current.parentElement;
  }
}

function is_selected_any_product(input,all_cards,selected_card) {
  let current = input.parentElement;  
  console.log("current test",current);
  while (current) {
    if (current.classList.contains("cust-form-wrapp")) {
      current.classList.add("is_selected");
    }
    current = current.parentElement;
  }

  // console.log("all_cards",all_cards);

  if(all_cards && selected_card){
    // console.log("all_cards",all_cards);

    const anyActive = Array.from(all_cards).some(card => card.classList.contains("active"));
    const nextBtn_conditional = selected_card.closest(".eighth_step")?.querySelector("next-btn.next_button_conditional");
    const nextBtn = selected_card.closest(".eighth_step")?.querySelector("next-btn.next_button");

    if (anyActive) {
      nextBtn?.classList.remove('hidden');
      nextBtn_conditional?.classList.add('hidden')
    }

  }
}
 function slider_storage(slider){    
  console.log("slkider",slider);
    const wrapper = slider.closest(".checkbox-accordion");
    const near_child = slider.closest("[value-of-details]")?.getAttribute("value-of-details");    
    if (!wrapper) return;
    const checkedChildren = wrapper.querySelectorAll(".child_parent:checked");
    if (!checkedChildren.length) return;

    const parentHeading = slider.closest(".show_hidden_content")?.getAttribute("data-heading-acc");
    let storedData = JSON.parse(localStorage.getItem("credit_accordion") || "[]");

    storedData.forEach(parent => {      
      if (parent.acc_title === parentHeading && parent.subObjects) {
        checkedChildren.forEach(checkbox => {          
          const childTitle = checkbox.value;          
          parent.subObjects.forEach(child => {   
            if (child.acc_title === childTitle) {                
              if(childTitle == near_child) child.qty = slider.value; 
            }
          });
        });
      }
    });
    localStorage.setItem("credit_accordion",JSON.stringify(storedData)
    );    
  }

document.querySelectorAll(".slider.custom-range").forEach(slider => {
    slider_storage(slider);
    slider.addEventListener("change", function () {
      slider_storage(slider);
    });
  });
summaryCheckboxAddLoac();

 // credit step 1 in accordion and also xs step 5 page result 
//  const acc_main_title = document.querySelectorAll(".configure-form-product-filter-inner input[name='contact[Filter]']");
//  const main_credit = document.querySelector(".credit_main_title");  
//  acc_main_title?.forEach(input => {
//     if (input.checked) {
//       const value = input.dataset.text;  
//       localStorage.setItem("credit_accordion_title",JSON.stringify(value));
//       main_credit.innerHTML= value;
//     }
//    input?.addEventListener("change", function () {   
//     console.log("input...",input) ;
//      const input_text = input.dataset.text;      
//      if(!input_text) return;
     
//      let storedData = JSON.parse(localStorage.getItem("credit_accordion_title") || "[]");
//      storedData = (storedData !== input_text);     
//        if (main_credit) main_credit.innerHTML = "";
 
//      if (storedData !== input_text) {
//        localStorage.setItem("credit_accordion_title", JSON.stringify(input_text));
//        main_credit.innerHTML= input_text;
//      }
//    });
//  });



  //======= accordion data ======//
  // const acc_show_credit = document.querySelector(".credit_accordion_result");
  // let storedData = JSON.parse(localStorage.getItem("credit_accordion") || "[]");

  // if (acc_show_credit && storedData.length > 0) {
  //   // 🔹 sort by index (ascending)
  //   storedData.sort((a, b) => a.index - b.index);

  //   storedData.forEach(({ index, acc_title, acc_content, subObjects }) => {
  //     console.log("calleld result");
  //     const parentDiv = document.createElement("div");
  //     parentDiv.className = "credit_accordion_item";
  //     parentDiv.dataset.index = index;

  //     const titleDiv = document.createElement("div");
  //     titleDiv.className = "show_credit_title";
  //     titleDiv.dataset.title = acc_title;
  //     titleDiv.textContent = acc_title;

  //     parentDiv.appendChild(titleDiv);

  //     if (Array.isArray(subObjects) && subObjects.length > 0) {
  //       const ul = document.createElement("ul");
  //       ul.className = "sub_credit_list";

  //       subObjects.forEach(sub => {
  //         const li = document.createElement("li");
  //         li.textContent = sub.acc_title;
  //         ul.appendChild(li);
  //       });

  //       parentDiv.appendChild(ul);
  //     }

  //     acc_show_credit.appendChild(parentDiv);
  //   });

  //   // removeLocalStorage();
  // }


  const result_step = document.querySelector(".show_selected_content");
  if (result_step) result_step.style.display = "none";

    function checkUrl() {
      const currentUrl = location.href;            
      const checkbox_check = document.querySelector(".credit_step_one");
      const sub_checkbox_check = document.querySelector(".ninth_step");
    
      if(checkbox_check) checkbox_check.style.display = "none";
      if(sub_checkbox_check) sub_checkbox_check.style.display = "none";

        const result_step_ = document.querySelector(".show_selected_content");
      if (result_step_) result_step_.style.display = "block";
        showResultAfterSubmitForm();   
        const cleanUrl = window.location.href.split('#')[0];
        history.replaceState(null, null, cleanUrl);
    }  
    // removeLocalStorage();
    
    // checkUrl();
    // setInterval(checkUrl, 1000);

function sortBlogPosts(option) {
  const postsContainers = document.querySelectorAll(".product-card-sorting");

  postsContainers?.forEach((postsContainer) => {
    const postsArray = Array.from(postsContainer.querySelectorAll(".cust_sort_blog"));

    switch (option) {
      case "title-ascending":
        postsArray.sort((a, b) => {
          const titleA = a.querySelector(".product-card-title").textContent.trim();
          const titleB = b.querySelector(".product-card-title").textContent.trim();
          return titleA.localeCompare(titleB);
        });
        break;

      case "title-descending":
        postsArray.sort((a, b) => {
          const titleA = a.querySelector(".product-card-title").textContent.trim();
          const titleB = b.querySelector(".product-card-title").textContent.trim();
          return titleB.localeCompare(titleA);
        });
        break;

      case "price-ascending":
        postsArray.sort((a, b) => {
          const priceA = parseFloat(
            a.querySelector(".price__container")?.textContent.replace(/[^0-9.]/g, "") || 0
          );
          const priceB = parseFloat(
            b.querySelector(".price__container")?.textContent.replace(/[^0-9.]/g, "") || 0
          );
          return priceA - priceB;
        });
        break;

      case "price-descending":
        postsArray.sort((a, b) => {
          const priceA = parseFloat(
            a.querySelector(".price__container")?.textContent.replace(/[^0-9.]/g, "") || 0
          );
          const priceB = parseFloat(
            b.querySelector(".price__container")?.textContent.replace(/[^0-9.]/g, "") || 0
          );
          return priceB - priceA;
        });
        break;

        case "date-newest":
          postsArray.sort((a, b) => {
            const dateA = new Date(a.querySelector(".created_date_product")?.textContent.trim() || 0);
            const dateB = new Date(b.querySelector(".created_date_product")?.textContent.trim() || 0);
            return dateB - dateA;
          });
          break;
  
        case "date-oldest":
          postsArray.sort((a, b) => {
            const dateA = new Date(a.querySelector(".created_date_product")?.textContent.trim() || 0);
            const dateB = new Date(b.querySelector(".created_date_product")?.textContent.trim() || 0);
            return dateA - dateB;
          });
          break;            

      default:
        return;
    }

    // Clear and re-append sorted posts
    postsContainer.innerHTML = "";
    postsArray.forEach((post) => postsContainer.appendChild(post));
  });
}

// Dropdown listeners
document.getElementById("sorting-dropdown")?.addEventListener("change", function () {
  sortBlogPosts(this.value);
});

document.getElementById("credit-sorting-dropdown")?.addEventListener("change", function () {
  sortBlogPosts(this.value);
});